import AxiosClient from "../../../services/axios.services";

class PoliticsAndProceduresServices {
  getPoliticsAndProcedures = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_politicas_procedimientos/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getPoliticsAndProceduresById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_politicas_procedimientos/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  savePoliticsAndProcedures = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_politicas_procedimientos/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPoliticsAndProcedures = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_politicas_procedimientos/${id}/`, data, {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePoliticsAndProcedures = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_politicas_procedimientos/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new PoliticsAndProceduresServices();
